'use client'

import { cn } from '@/app/utils'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

const supportedLocales = ['en', 'ja', 'ko']

export default function FooterNavLink(props: {
  children: React.ReactNode
  link: string
}) {
  const pathname = usePathname()
  const segments = pathname?.split('/') || []
  const maybeLocale = segments[1]

  const hasLocale = supportedLocales.includes(maybeLocale)
  const normalizedPath = hasLocale
    ? '/' + segments.slice(2).join('/')
    : pathname

  return (
    <Link
      href={props.link}
      className={cn(
        `c-b5 flex flex-col items-center justify-center gap-2 text-text-subtler`,
        {
          'text-fblue [&>svg]:fill-fblue': normalizedPath === props.link,
        },
      )}>
      {props.children}
    </Link>
  )
}
